import { useSyncExternalStore } from 'react';

/** «Скрыть финансовые данные» (Алексей 27.10 #2956): кнопка в шапке сайдбара, на этом устройстве.
 *  Форматтеры денег пропускают строку через money() — при включённом режиме вместо суммы маска. */
const KEY = 'hide_finance';
let hidden = (() => {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
})();
const subs = new Set<() => void>();

export const isFinanceHidden = () => hidden;

export function setFinanceHidden(v: boolean) {
  hidden = v;
  try {
    localStorage.setItem(KEY, v ? '1' : '0');
  } catch {
    /* приватный режим — только на эту вкладку */
  }
  subs.forEach((f) => f());
}

export function useFinanceHidden() {
  return useSyncExternalStore((f) => {
    subs.add(f);
    return () => subs.delete(f);
  }, isFinanceHidden);
}

export const MONEY_MASK = '••• ₽';
export const money = (s: string) => (hidden ? MONEY_MASK : s);
